import * as CookieConsent from 'vanilla-cookieconsent';
import {
  COOKIE_CATEGORY_ADVERTISEMENT,
  COOKIE_CATEGORY_ANALYTICS,
  COOKIE_CATEGORY_NECESSARY,
  COOKIE_CONSENT_EXCLUDED_SEGMENTS,
} from './cookie-consent.constants';

export interface CookieConsentI18n {
  AcceptAll: string;
  AcceptNecessary: string;
  AnalyticsDescription: string;
  AnalyticsTitle: string;
  BannerDescription: string;
  BannerTitle: string;
  ClosePreferences: string;
  CookiePolicy: string;
  IntroDescription: string;
  IntroTitle: string;
  MarketingDescription: string;
  MarketingTitle: string;
  MoreInfoDescription: string;
  MoreInfoTitle: string;
  NecessaryDescription: string;
  NecessaryTitle: string;
  PreferencesTitle: string;
  PrivacyPolicy: string;
  SavePreferences: string;
  ShowPreferences: string;
}

function policyLink(communityCode: string | null, type: 'privacy' | 'cookies', label: string): string {
  if (!communityCode || !label) {
    return '';
  }

  return `<a href="/${communityCode}/policies/${type}" target="_blank" rel="noopener noreferrer">${label}</a>`;
}

export function communityCodeFromUrl(url: string): string | null {
  const path = (url || '').split('?')[0].split('#')[0];
  const first = path.split('/').find(segment => !!segment);
  if (!first || COOKIE_CONSENT_EXCLUDED_SEGMENTS.includes(first)) {
    return null;
  }

  return first;
}

export function mapCookieConsentTranslation(
  texts: Partial<CookieConsentI18n> | null | undefined,
  communityCode: string | null
): CookieConsent.Translation {
  const t = texts ?? {};
  const privacyLink = policyLink(communityCode, 'privacy', t.PrivacyPolicy ?? '');
  const cookiesLink = policyLink(communityCode, 'cookies', t.CookiePolicy ?? '');
  const moreInfoDescription = [t.MoreInfoDescription, cookiesLink].filter(Boolean).join(' ');

  return {
    consentModal: {
      title: t.BannerTitle,
      description: t.BannerDescription,
      acceptAllBtn: t.AcceptAll,
      acceptNecessaryBtn: t.AcceptNecessary,
      showPreferencesBtn: t.ShowPreferences,
      footer: `${privacyLink}${cookiesLink}`,
    },
    preferencesModal: {
      title: t.PreferencesTitle,
      acceptAllBtn: t.AcceptAll,
      acceptNecessaryBtn: t.AcceptNecessary,
      savePreferencesBtn: t.SavePreferences,
      closeIconLabel: t.ClosePreferences,
      sections: [
        {
          title: t.IntroTitle,
          description: t.IntroDescription,
        },
        {
          title: t.NecessaryTitle,
          description: t.NecessaryDescription,
          linkedCategory: COOKIE_CATEGORY_NECESSARY,
        },
        {
          title: t.AnalyticsTitle,
          description: t.AnalyticsDescription,
          linkedCategory: COOKIE_CATEGORY_ANALYTICS,
        },
        {
          title: t.MarketingTitle,
          description: t.MarketingDescription,
          linkedCategory: COOKIE_CATEGORY_ADVERTISEMENT,
        },
        {
          title: t.MoreInfoTitle,
          description: moreInfoDescription,
        },
      ],
    },
  };
}
